import * as React from "react";
import * as ReactDOM from "react-dom";
import { IOWidget, Options, Fun, Option, mk_widget, option } from "../widget";

export interface WaitProps<i> {
  options?:Options
  input:() => i
  on_done:(output_s:i) => void
  milliseconds:number
}
export interface WaitState<s> {
}
export class Wait<s> extends React.Component<WaitProps<s>, WaitState<s>> {
  constructor(props:WaitProps<s>, context:any) {
    super(props, context)

    this.state = { value:props.input }
  }

  timer?:number
  on_new_input(new_s:() => s) {
    if (this.timer == undefined) {
      this.timer = window.setTimeout(() => {
        if (this.timer != undefined) {
          this.timer = undefined
          this.props.on_done(new_s())
        }
      }, this.props.milliseconds)
    }
  }

  componentWillReceiveProps(new_props:WaitProps<s>) {
    this.on_new_input(new_props.input)
  }
  componentDidMount() {
    this.on_new_input(this.props.input)
  }
  componentWillUnmount() { this.timer = undefined }

  render() {
    return this.timer ?
      <React.Fragment
        key={option("key", this.props.options)} />
      : null
  }
}
export let wait = function<io>(milliseconds:number, options?:Options) : IOWidget<() => io,io> {
  return (input:() => io) => mk_widget({
    run:(on_done:(output:io) => void) =>
      React.createElement<WaitProps<io>>(Wait, { on_done, input, milliseconds, options })
  })
}
